import { useState } from "react";
import { Row, Col, Drawer } from "antd";
import { withTranslation, TFunction } from "react-i18next";
import Container from "../../common/Container";
import { Button } from "../../common/Button";
import {
  HeaderSection,
  LogoContainer,
  Burger,
  NotHidden,
  CustomNavLinkSmall,
  Label,
  Outline,
  Span,
} from "./styles";

const Header = ({ t }: { t: TFunction }) => {
  const [visible, setVisibility] = useState(false);

  const toggleButton = () => {
    setVisibility(!visible);
  };

  const MenuItem = () => {
    const scrollTo = (id: string) => {
      const element = document.getElementById(id) as HTMLDivElement;
      element.scrollIntoView({
        behavior: "smooth",
      });
      setVisibility(false);
    };
    return (
      <>
        <CustomNavLinkSmall onClick={() => scrollTo("about")}>
          <Span>{t("About")}</Span>
        </CustomNavLinkSmall>
        {/* Temporarily hidden — sections commented out in Home
        <CustomNavLinkSmall onClick={() => scrollTo("gamekit")}>
          <Span>{t("Pixel Kit")}</Span>
        </CustomNavLinkSmall>
        <CustomNavLinkSmall onClick={() => scrollTo("games")}>
          <Span>{t("Games")}</Span>
        </CustomNavLinkSmall>
        */}
        <CustomNavLinkSmall onClick={() => scrollTo("contact")}>
          <Button>{t("Contact")}</Button>
        </CustomNavLinkSmall>
      </>
    );
  };

  return (
    <HeaderSection id='header'>
      <Container>
        <Row justify="space-between">
          <LogoContainer to="/" aria-label="homepage">
            <img srcSet="/img/pngs/logo2x.png 2x" src="/img/pngs/logo1x.png" alt="Pixel King Gaming logo" />
          </LogoContainer>
          <NotHidden>
            <MenuItem />
          </NotHidden>
          <Burger onClick={toggleButton}>
            <Outline />
          </Burger>
        </Row>
        <Drawer closable={false} open={visible} onClose={toggleButton}>
          <Col style={{ marginBottom: "2.5rem" }}>
            <Label onClick={toggleButton}>
              {/* <Col span={12}> */}
              <Col style={{ display: 'flex', justifyContent: 'center', width: '100%', filter: 'brightness(0) invert(1)' }}>
                {/* <Menu>Pixel King</Menu> */}
                <Outline />
              </Col>
              {/* <Col span={12}>
                <Outline />
              </Col> */}
            </Label>
          </Col>
          <MenuItem />
        </Drawer>
      </Container>
    </HeaderSection>
  );
};

export default withTranslation()(Header);
